import { CalendarPetListType } from "^/customer/calendar";
import { useCalendarPetList } from "~/services/customer/calendar";
import { useMypageMain } from "~/services/customer/myPage";

const useMyPageMain = () => {
  const {
    data: calendarPetList,
    isLoading: isPetListLoading,
    isFetching: isPetListFetching,
  } = useCalendarPetList();
  const {
    data: mypageMain,
    isLoading: isMypageLoading,
    isFetching: isMypageFetching,
  } = useMypageMain();
  const petList = calendarPetList?.map((item: CalendarPetListType) => {
    return {
      seq: item.petSeq,
      title: item.petName,
      description: item.petBreed + " | " + item.petWeight + "kg",
      description1: item.petAge,
      image: item.fileUrl || "",
      linked: item.linkedYn === "Y",
      linkedOwnerName: item.linkedOwnerName,
      linkedOwnerImageUrl: item.linkedOwnerImageUrl,
    };
  });

  return {
    petList,
    mypageMain,
    isLoading: isPetListLoading || isMypageLoading,
    isFetching: isPetListFetching || isMypageFetching,
  };
};

export default useMyPageMain;
